import debounce from './debounce/debounce'
import inputDebounce from './debounce/input-debounce'
import dialogDrag from './dialogDrag/dialogDrag'
import diagZoom from './diagZoom/diagZoom'

const install = function (Vue) {
  Vue.directive('debounce', debounce)
  Vue.directive('input-debounce', inputDebounce)
  Vue.directive('dialogDrag', dialogDrag)
  Vue.directive('diagZoom', diagZoom)
}

if (window.Vue) {
  window['debounce'] = debounce
  window['inputDebounce'] = inputDebounce
  window['dialogDrag'] = dialogDrag
  window['diagZoom'] = diagZoom

  Vue.use(install); // eslint-disable-line
}

export default install



// WEBPACK FOOTER //
// ./src/directive/index.js